class AboutCtrl{

}

export default AboutCtrl;


// WEBPACK FOOTER //
// ./app/scripts/controllers/about.js